import React, { useState, useRef, useEffect } from "react";

export default function FloatingMariaChat() {
  const [isOpen, setIsOpen] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: "maria",
      text: "Olá! Sou a MarIA ✨ Sua assistente virtual de saúde e uso do sistema. Como posso te ajudar hoje?",
    },
  ]);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (isOpen) {
      scrollToBottom();
    }
  }, [messages, isOpen]);

  const quickQuestions = [
    { label: "⚖️ Como registrar peso?", text: "Como faço para registrar meu peso?" },
    { label: "📅 Como funciona a rotina?", text: "Como funciona o controle de doses e rotina?" },
    { label: "🎯 Como editar metas?", text: "Como editar minhas metas e prazos?" },
    { label: "🩺 Como registrar pressão?", text: "Como registrar a pressão arterial?" },
  ];

  const handleSendMessage = (textToSend) => {
    const query = textToSend || inputMessage.trim();
    if (!query) return;

    const userMsg = {
      id: Date.now(),
      sender: "user",
      text: query,
    };

    setMessages((prev) => [...prev, userMsg]);
    if (!textToSend) setInputMessage("");

    // Resposta simulada inteligente da MarIA
    setTimeout(() => {
      let reply = "Para navegar no sistema, utilize o menu na barra inferior ou toque no card correspondente na tela de Início! Se tiver dúvidas sobre uma medição específica, estou à disposição.";
      const lower = query.toLowerCase();

      if (lower.includes("peso")) {
        reply = "Para registrar seu peso, toque no card 'Peso' na tela inicial ou acesse o menu de Registros. Você poderá cadastrar o valor atual, a data e definir sua meta de peso!";
      } else if (lower.includes("rotina") || lower.includes("dose") || lower.includes("medicação")) {
        reply = "Na aba 'Rotina' (ícone de calendário no menu inferior), você pode visualizar todas as doses e lembretes do dia, marcando o horário de tomada em 1 clique!";
      } else if (lower.includes("meta") || lower.includes("prazos")) {
        reply = "Na página dedicada de cada medição (Peso, Pressão, Glicemia, Medidas), existe o card 'Meta' com o botão 'Editar Meta' para ajustar o valor desejado e a frequência (1, 3, 7, 14 ou 30 dias).";
      } else if (lower.includes("pressão") || lower.includes("glicemia")) {
        reply = "Para registrar Pressão Arterial ou Glicemia, toque no card correspondente na Início. Digite os valores (ex: 120/80 mmHg para pressão ou o valor em mg/dL para glicemia).";
      } else if (lower.includes("diário") || lower.includes("sintoma")) {
        reply = "No 'Diário de Bordo' (acessível no menu), você pode registrar como está se sentindo hoje, nível de sono, energia e sintomas para calcular seu Score de Bem-estar!";
      }

      const mariaMsg = {
        id: Date.now() + 1,
        sender: "maria",
        text: reply,
      };

      setMessages((prev) => [...prev, mariaMsg]);
    }, 600);
  };

  return (
    <>
      {/* BOTÃO FLUTUANTE DE AÇÃO (FAB NO CANTO INFERIOR DIREITO) */}
      <div className="fixed bottom-20 right-4 z-50 flex items-center gap-2">
        {!isOpen && (
          <div
            onClick={() => setIsOpen(true)}
            className="hidden sm:flex items-center gap-2 bg-white/95 backdrop-blur-md px-3.5 py-2 rounded-2xl shadow-lg border border-purple-200/80 text-xs font-bold text-[#24152F] cursor-pointer hover:scale-105 transition-all duration-300"
          >
            <span>🤖 Dúvidas? Fale com a MarIA</span>
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-ping" />
          </div>
        )}

        <button
          onClick={() => setIsOpen((v) => !v)}
          aria-label="Abrir assistente virtual MarIA"
          className="relative group flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-tr from-[#6C54D8] to-[#8C76EC] text-white shadow-xl hover:scale-105 active:scale-95 transition-all duration-300 border-2 border-white/80 cursor-pointer"
        >
          <span className="text-2xl">🤖</span>
          <span className="absolute -top-1 -right-1 flex h-4 w-4">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-4 w-4 bg-purple-600 border-2 border-white text-[9px] font-black text-white justify-center items-center">
              ?
            </span>
          </span>
        </button>
      </div>

      {/* JANELA / MODAL DE CHAT FLUTUANTE */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 bg-black/40 backdrop-blur-xs animate-in fade-in duration-200">
          <div className="bg-white w-full sm:max-w-md h-[85vh] sm:h-[600px] rounded-t-3xl sm:rounded-3xl shadow-2xl flex flex-col overflow-hidden border border-purple-100">
            {/* CABEÇALHO DO CHAT */}
            <div className="bg-gradient-to-r from-[#6C54D8] via-[#7B63E4] to-[#917CF0] p-4 text-white flex items-center justify-between shrink-0 shadow-md">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center text-xl shadow-inner border border-white/30">
                  🤖
                </div>
                <div>
                  <h3 className="text-base font-bold leading-tight">MarIA Assistente</h3>
                  <p className="text-[11px] text-purple-100 flex items-center gap-1 font-medium">
                    <span className="w-2 h-2 rounded-full bg-emerald-400" /> Online para tirar dúvidas
                  </p>
                </div>
              </div>

              <button
                onClick={() => setIsOpen(false)}
                className="w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white text-base font-bold transition-colors cursor-pointer"
              >
                ✕
              </button>
            </div>

            {/* CORPO DE MENSAGENS */}
            <div className="flex-1 p-4 overflow-y-auto space-y-3 bg-[#FAFAFE]">
              {messages.map((msg) => (
                <div
                  key={msg.id}
                  className={`flex items-start gap-2.5 ${
                    msg.sender === "user" ? "justify-end ml-auto max-w-[85%]" : "max-w-[88%]"
                  }`}
                >
                  {msg.sender === "maria" && (
                    <div className="w-8 h-8 rounded-xl bg-purple-100 flex items-center justify-center text-sm shrink-0 font-bold border border-purple-200">
                      🤖
                    </div>
                  )}

                  <div
                    className={`p-3.5 text-xs leading-relaxed ${
                      msg.sender === "user"
                        ? "bg-[#6C54D8] text-white rounded-2xl rounded-br-xs font-semibold shadow-xs"
                        : "bg-white text-[#24152F] rounded-2xl rounded-tl-xs shadow-2xs border border-purple-100/80 font-medium space-y-1"
                    }`}
                  >
                    {msg.text}
                  </div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>

            {/* SUGESTÕES RÁPIDAS EM PÍLULAS */}
            <div className="px-3 py-2 bg-white border-t border-purple-50 flex items-center gap-1.5 overflow-x-auto text-xs shrink-0 no-scrollbar">
              {quickQuestions.map((q, idx) => (
                <button
                  key={idx}
                  onClick={() => handleSendMessage(q.text)}
                  className="px-3 py-1.5 rounded-full bg-purple-50 hover:bg-purple-100 text-[#6C54D8] font-bold text-[11px] whitespace-nowrap transition-colors border border-purple-200/60 cursor-pointer"
                >
                  {q.label}
                </button>
              ))}
            </div>

            {/* ENVIAR MENSAGEM */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSendMessage();
              }}
              className="p-3 bg-white border-t border-purple-100 flex items-center gap-2 shrink-0"
            >
              <input
                type="text"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                placeholder="Digite sua dúvida aqui..."
                className="flex-1 h-11 px-4 rounded-2xl bg-gray-50 border border-purple-100 text-xs font-semibold focus:outline-none focus:border-[#6C54D8] focus:bg-white transition-all"
              />
              <button
                type="submit"
                className="w-11 h-11 rounded-2xl bg-[#6C54D8] hover:bg-[#5A45BF] text-white flex items-center justify-center transition-transform active:scale-95 shadow-md cursor-pointer shrink-0"
              >
                <svg className="w-5 h-5 rotate-90" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 19V5m0 0l-7 7m7-7l7 7" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
